import { TBuyerOffer, TBuyerOfferResponse } from './offer.types';

export const mockBuyerOffer: TBuyerOffer = {
    listingId: '',
    sellerPbConnected: false,
    isBuyerProfileComplete: false,
    closingDate: new Date(),
    previousShowingExpertId: 1,
    property: {
        address: '',
        id: 1,
        imageUrl: '',
        lastActionCompleted: 0,
        otherNotesOfInterestCount: 0,
        priceText: '',
        regionType: 'England',
        timeZone: '',
        pbProtectApplicable: false,
    },
    buyerDetails: {
        id: 1,
        homeTelephone: '',
        mobile: '',
        otherTelephone: '',
        primaryContactNumberType: 'Home',
    },
    buyers: [],
    buyerAdditionalDetails: {
        propertyId: 1,
    },
    extras: [],
    defaultLawyer: {
        county: '',
        email: '',
        firm: '',
        hasGetQuoteBanner: false,
        hasPayAtSettlement: false,
        hasUnlockedEzieLawyer: false,
        id: 1,
        isDeferredPayment: false,
        line1: '',
        line2: '',
        name: '',
        postcode: '',
        reference: '',
        telephone: '',
        town: '',
        deferredPaymentMethod: 'Card',
    },
    userType: 'Customer',
};

export const mockBuyerOfferResponse: TBuyerOfferResponse = {
    buyerOffer: mockBuyerOffer,
    status: 200,
};
